import React from 'react';
import PropTypes from 'prop-types';
import {
    FieldListWrapper,
    FieldListInnerWrapper,
    FieldListDividerWrapper
} from '../BoxscoreInfo.style';

const FieldList = (props) => {
    const { list = [], divider = ' ' } = props;
    return list.map(({ label, value }, i) => {
        return (
            <FieldListWrapper key={i}>
                <FieldListInnerWrapper>{label}</FieldListInnerWrapper>
                {divider && value && <FieldListDividerWrapper>{divider}</FieldListDividerWrapper>}
                { value }
            </FieldListWrapper>
        );
    });
};

FieldList.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        fieldList: PropTypes.array
    })),
    divider: PropTypes.string
};

export default FieldList;
